import { render, staticRenderFns } from "./WsInfoBelongsTo.vue?vue&type=template&id=a60466b6&"
import script from "./WsInfoBelongsTo.vue?vue&type=script&lang=js&"
export * from "./WsInfoBelongsTo.vue?vue&type=script&lang=js&"
import style0 from "./WsInfoBelongsTo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports